/* ===== EN Lieferdatum-Rechner — füllt [data-delivery-estimate] mit echtem, lokalisiertem Datum =====
   Regeln:
   - Versand (Abgang) nur Mo–Fr, keine Feiertage; Cutoff 11:00 Uhr (danach nächster Versandtag)
   - Zustellung Mo–Sa, NICHT Sonntag, NICHT Feiertage
   - Laufzeit 3–5 Werktage  (Sa zählt als Zustelltag)
   - Deutsche bundesweite Feiertage dynamisch (Oster-Algorithmus) → jahresunabhängig
   - Texte + Locale aus window.enI18n (übersetzbare Sprachbausteine); Datum via Intl.DateTimeFormat
*/
(function () {
  if (window.__enDeliveryInit) return;
  window.__enDeliveryInit = 1;

  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function key(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }

  // Ostersonntag (Anonymous Gregorian / Gauss)
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, mo - 1, da);
  }
  function holidaysForYear(y) {
    var e = easter(y), s = {};
    function add(d) { s[key(d)] = 1; }
    add(new Date(y, 0, 1));      // Neujahr
    add(addDays(e, -2));         // Karfreitag
    add(addDays(e, 1));          // Ostermontag
    add(new Date(y, 4, 1));      // Tag der Arbeit
    add(addDays(e, 39));         // Christi Himmelfahrt
    add(addDays(e, 50));         // Pfingstmontag
    add(new Date(y, 9, 3));      // Tag der Deutschen Einheit
    add(new Date(y, 11, 25));    // 1. Weihnachtstag
    add(new Date(y, 11, 26));    // 2. Weihnachtstag
    return s;
  }
  var H = {};
  function isHoliday(d) { var y = d.getFullYear(); if (!H[y]) H[y] = holidaysForYear(y); return !!H[y][key(d)]; }
  function isShipDay(d) { var w = d.getDay(); return w >= 1 && w <= 5 && !isHoliday(d); }   // Mo–Fr
  function isDeliveryDay(d) { var w = d.getDay(); return w !== 0 && !isHoliday(d); }         // Mo–Sa, nicht So/Feiertag
  function nextShipDay(from) { var d = new Date(from); while (!isShipDay(d)) d = addDays(d, 1); return d; }
  function addDeliveryDays(start, n) { var d = new Date(start), c = 0; while (c < n) { d = addDays(d, 1); if (isDeliveryDay(d)) c++; } return d; }

  function i18n() { return window.enI18n || {}; }
  function locale() { return i18n().locale || document.documentElement.lang || 'de'; }
  function fmtDate(d) {
    var nb = String.fromCharCode(160);
    try { return new Intl.DateTimeFormat(locale(), { weekday: 'short', day: 'numeric', month: 'long' }).format(d).replace(/[\s\u202f]/g, nb); }
    catch (e) { return d.getDate() + '.' + nb + (d.getMonth() + 1) + '.'; }
  }

  function compute() {
    var t = i18n();
    var now = new Date();
    var base = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (now.getHours() >= 11) base = addDays(base, 1);   // Cutoff 11:00
    var ship = nextShipDay(base);
    var early = addDeliveryDays(ship, 3);
    var late = addDeliveryDays(ship, 5);
    if (early.getTime() === late.getTime())
      return (t.deliverySingle || 'Lieferung am %DATE%').replace('%DATE%', fmtDate(early));
    return (t.deliveryRange || 'Lieferung %FROM% – %TO%').replace('%FROM%', fmtDate(early)).replace('%TO%', fmtDate(late));
  }

  // CSS :has() wird von alten Browsern (Safari <15.4, alte Android-Chrome) nicht unterstützt.
  // Dort greift die Regel „leerer Warenkorb → Lieferzeile ausblenden" nicht → JS-Alternative.
  var HAS_SUPPORT;
  function supportsHas() {
    try { return !!(window.CSS && CSS.supports && CSS.supports('selector(:has(*))')); } catch (e) { return false; }
  }
  function ancestorTag(el, tag) {
    while (el) { if (el.tagName && el.tagName.toLowerCase() === tag) return el; el = el.parentElement || el.parentNode; }
    return null;
  }
  function emptyFallback() {
    if (HAS_SUPPORT === undefined) HAS_SUPPORT = supportsHas();
    if (HAS_SUPPORT) return;                              // moderne Browser: CSS :has() erledigt es
    var lines = document.querySelectorAll('.cart-drawer__delivery');
    for (var j = 0; j < lines.length; j++) {
      var cd = ancestorTag(lines[j], 'cart-drawer');
      if (!cd) continue;
      lines[j].style.display = cd.querySelector('.cart-item') ? '' : 'none';
    }
  }

  var cached = null;
  function fill() {
    emptyFallback();
    var els = document.querySelectorAll('[data-delivery-estimate]:not([data-en-done])');
    if (!els.length) return;
    if (cached === null) { try { cached = compute(); } catch (e) { return; } }
    for (var i = 0; i < els.length; i++) { els[i].textContent = cached; els[i].setAttribute('data-en-done', '1'); }
  }

  function boot() {
    fill();
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return; scheduled = true;
      setTimeout(function () { scheduled = false; fill(); }, 120);
    });
    obs.observe(document.body, { childList: true, subtree: true });   // dauerhaft: füllt neue Platzhalter nach jedem Cart-/Tab-Re-Render
  }
  document.addEventListener('en:cart-updated', fill);
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
